import { inject } from 'aurelia-framework';
import { Setup } from 'startup/setup';

import 'bootstrap';
import 'styles/styles.scss';

@inject(Setup)
export class Auth {
    constructor(setup) {
        setup.configureFetch();
    }

    attached() {
        Waves.init();
    }

    configureRouter(config, router) {
        this.router = router;
        config.title = 'Quote DB';
        config.options.pushState = true;
        config.map([
            {
                route: ['', 'session'],
                name: 'login',
                title: 'Login',
                moduleId: PLATFORM.moduleName('pages/login/index')
            }
        ]);
        config.mapUnknownRoutes(PLATFORM.moduleName('pages/login/index'));
    }
}